//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Mechatronics.js";
import "../no/Builder.js";
let d=[[[0,"OutputFile",1,0],[0,"OutputFolder",1,0]],[[["nGroups","mechanicalData"],"GetMcdMechanicalData",{},0,0],[["mechanicalData"],"SetMcdMechanicalData",{},1,0],[["startTime","endTime"],"ProcessMcdSimulationData",{},2,0],[[],"GetGearParameters",{R_:{gearParams:''}},0,0],[["gearParams"],"SetGearParameters",{},1,0]],[]];
SPLM.Mechatronics.ExportLoadCurveBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Mechatronics.ExportLoadCurveBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Mechatronics.ExportLoadCurveBuilder.MechanicalData = class{
    constructor(id,name,axisControl,referenceDesignator,frictionTorque,systemEfficiency,loadInertia,additionalInertia){
        this.id=id;this.name=name;this.axisControl=axisControl;this.referenceDesignator=referenceDesignator;this.frictionTorque=frictionTorque;this.systemEfficiency=systemEfficiency;this.loadInertia=loadInertia;this.additionalInertia=additionalInertia;}
    get Id(){return this.id}
    set Id(val){this.id = val}
    get Name(){return this.name}
    set Name(val){this.name = val}
    get Axiscontrol(){return this.axisControl}
    set Axiscontrol(val){this.axisControl = val}
    get Referencedesignator(){return this.referenceDesignator}
    set Referencedesignator(val){this.referenceDesignator = val}
    get Frictiontorque(){return this.frictionTorque}
    set Frictiontorque(val){this.frictionTorque = val}
    get Systemefficiency(){return this.systemEfficiency}
    set Systemefficiency(val){this.systemEfficiency = val}
    get Loadinertia(){return this.loadInertia}
    set Loadinertia(val){this.loadInertia = val}
    get Additionalinertia(){return this.additionalInertia}
    set Additionalinertia(val){this.additionalInertia = val}
};

SPLM.Mechatronics.ExportLoadCurveBuilder.MCDGearParameters = class{
    constructor(enable,ratio,efficiency,inertia){
        this.enable=enable;this.ratio=ratio;this.efficiency=efficiency;this.inertia=inertia;}
    get Enable(){return this.enable}
    set Enable(val){this.enable = val}
    get Ratio(){return this.ratio}
    set Ratio(val){this.ratio = val}
    get Efficiency(){return this.efficiency}
    set Efficiency(val){this.efficiency = val}
    get Inertia(){return this.inertia}
    set Inertia(val){this.inertia = val}
};

export default SPLM;